import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: 'deleteActionCost',
    serviceName: 'labadmin',
    query: gql`
      mutation deleteActionCost($ids: [String]!) {
        deleteActionCost(ids: $ids) {
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
